import { api, ApiResponse } from './api';
import { Application, ApplicationStatus } from '../types';

export interface ApplicationFilters {
  status?: ApplicationStatus | 'all';
  searchTerm?: string;
  page?: number;
  limit?: number;
}

export interface UpdateApplicationStatusDTO {
  status: ApplicationStatus;
  rejectionReason?: string;
  interviewDate?: string;
  interviewNotes?: string;
}

export interface BulkUpdateApplicationsDTO {
  applicationIds: string[];
  status: ApplicationStatus;
  rejectionReason?: string;
}

class ApplicationService {
  // 병원별 지원서 목록 조회
  async getApplications(hospitalId: string, filters?: ApplicationFilters): Promise<ApiResponse<{
    applications: Application[];
    total: number;
    page: number;
    limit: number;
  }>> {
    const params = new URLSearchParams();
    
    if (filters?.status && filters.status !== 'all') {
      params.append('status', filters.status);
    }
    if (filters?.searchTerm) {
      params.append('search', filters.searchTerm);
    }
    if (filters?.page) {
      params.append('page', filters.page.toString());
    }
    if (filters?.limit) {
      params.append('limit', filters.limit.toString());
    }

    const response = await api.get(`/applications/hospital/${hospitalId}?${params.toString()}`);
    return response.data;
  }  // 지원서 상세 조회
  async getApplicationById(id: string): Promise<ApiResponse<Application>> {
    const response = await api.get(`/applications/${id}`);
    return response.data;
  }

  // 지원서 상태 변경
  async updateApplicationStatus(id: string, data: UpdateApplicationStatusDTO): Promise<ApiResponse<Application>> {
    const response = await api.patch(`/applications/${id}/status`, data);
    return response.data;
  }

  // 다중 지원서 상태 일괄 변경
  async bulkUpdateApplications(data: BulkUpdateApplicationsDTO): Promise<ApiResponse<{
    updatedCount: number;
    failedUpdates: { id: string; error: string }[];
  }>> {
    const response = await api.post('/applications/bulk-update', data);
    return response.data;
  }

  // 지원서 삭제
  async deleteApplication(id: string): Promise<ApiResponse<void>> {
    const response = await api.delete(`/applications/${id}`);
    return response.data;
  }

  // 지원서 노트 추가
  async addApplicationNote(applicationId: string, content: string): Promise<ApiResponse<any>> {
    const response = await api.post(`/applications/${applicationId}/notes`, { content });
    return response.data;
  }

  // 지원서 노트 목록 조회
  async getApplicationNotes(applicationId: string): Promise<ApiResponse<any[]>> {
    const response = await api.get(`/applications/${applicationId}/notes`);
    return response.data;
  }
}

export const applicationService = new ApplicationService();
export default applicationService;